import { useEffect, useState, SyntheticEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Link, Tab, Tabs } from "@mui/material";
import block from "bem-cn";
import { observer } from "mobx-react";

import { dashboardStore, charactersStore } from "stores";

import MainPageHeader from "pages/MainPage/components/MainPageHeader/MainPageHeader";
import { Loader } from "components/CommonComponents";
import { RouterPathEnum } from "shared/enums/commonEnums";

import { StatisticsComponent } from "./components";

import "./DashboardPage.scss";

const cnDashboardPage = block("DashboardPage");

enum DashboardPageTabs {
  TableTab,
  StatisticsPage,
  Gesture,
  Strength,
}

const tabs = [
  { key: DashboardPageTabs.StatisticsPage, value: "Статистика" },
  { key: DashboardPageTabs.Gesture, value: "Жесты" },
];

const DashboardPage = () => {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState<DashboardPageTabs>(
    DashboardPageTabs.StatisticsPage
  );

  const onChangeTab = (_event: SyntheticEvent, newValue: number) => {
    dashboardStore.clearSelectedJoint();
    dashboardStore.selectedGesture = null;
    setCurrentTab(newValue);
  };

  const getTab = () => {
    switch (currentTab) {
      case DashboardPageTabs.StatisticsPage:
        return <StatisticsComponent tab="stats" />;
      case DashboardPageTabs.Gesture:
        return (
          <StatisticsComponent
            tab="gesture"
            columnsNames={
              !!Object.keys(dashboardStore.GestureLoader2.data).length
                ? [
                    "Жест",
                    `Медиана За первую дату`,
                    "За среднюю дату",
                    "За последнюю дату",
                  ]
                : ["Жест", "Медиана"]
            }
          />
        );
    }
  };

  useEffect(() => {
    // Автозагрузка выбранного персонажа и его данных
    if (
      !charactersStore.selectedCharacter &&
      charactersStore.characters.length > 0
    ) {
      charactersStore.selectCharacter(charactersStore.characters[0].id);
      charactersStore.loadCharacterData("default"); // можно выбрать нужный уровень
    }
  }, [charactersStore.characters]);

  return (
    <div className={cnDashboardPage()}>
      <MainPageHeader />
      <div className={cnDashboardPage("header")}>
        <Tabs
          value={currentTab}
          onChange={onChangeTab}
          className={cnDashboardPage("tabs").toString()}
        >
          {tabs.map((tab) => (
            <Tab
              label={tab.value}
              value={tab.key}
              key={tab.key}
              className={cnDashboardPage("tab").toString()}
            />
          ))}
        </Tabs>

        {/* 3D Model */}
        {charactersStore.selectedCharacter?.name && (
          <Link
            className={cnDashboardPage("link").toString()}
            variant="body1"
            onClick={() => navigate(RouterPathEnum.SceneMuscle)}
          >
            3D Model
          </Link>
        )}
      </div>

      {/* Loader */}
      <Loader visible={charactersStore.isLoading} />

      {/* Контент */}
      <div className={cnDashboardPage("content")}>{getTab()}</div>
    </div>
  );
};

export default observer(DashboardPage);
